import { openBlock as s, createElementBlock as o, normalizeClass as n, renderSlot as r } from "vue";
/* empty css                    */
import a from "./design-system.es128.js";
const d = {
  name: "DsMenuItemSubtext",
  props: {
    /**
     * Whether the menu item is selected
     */
    selected: Boolean
  }
};
function c(e, u, t, m, l, i) {
  return s(), o("div", {
    class: n(["subtext ds-menu-item-subtext", { "ds-menu-item-subtext--selected": t.selected }])
  }, [
    r(e.$slots, "default", {}, void 0, !0)
  ], 2);
}
const x = /* @__PURE__ */ a(d, [["render", c], ["__scopeId", "data-v-aa2f94ed"]]);
export {
  x as default
};
//# sourceMappingURL=design-system.es290.js.map
